import { Component, OnDestroy } from '@angular/core';
import { NavComponent } from '../components/nav/nav.component';
import { FooterComponent } from '../components/footer/footer.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-imprint',
    imports: [NavComponent, FooterComponent, TranslateModule],
    templateUrl: './imprint.component.html',
    styleUrl: './imprint.component.scss'
})
export class ImprintComponent implements OnDestroy {
  constructor(private translate: TranslateService, private title: Title) {
    translate.get(['meta.title', 'footer.imprint']).subscribe((res: any) => {
      title.setTitle(res['footer.imprint'] + ' - ' + res['meta.title']);
    });
  }

  ngOnDestroy(): void {
    this.translate.get('meta.title').subscribe((res: string) => {
      this.title.setTitle(res);
    });
  }
}
